import { Component } from '@angular/core';

import { LoginService } from 'app/services/login.service';
import { CommonDataService } from 'app/services/common-data.service';

@Component({
    selector: 'nav-menu',
    templateUrl: './navmenu.component.html',
    styleUrls: ['./navmenu.component.css']
})
export class NavMenuComponent {
    constructor(private readonly loginService: LoginService, private readonly commonData: CommonDataService) {
        this.collapsed = localStorage['MainMenuCollapsed'] === 'true';
    }

    private useMenu: boolean;

    private collapsed: boolean;

    private logout = (): boolean => {
        this.loginService.logout().subscribe(data => {
            if (data.success)
                window.location.reload();
        }, e => this.commonData.showErrors([e.message || e]));

        return false;
    }

    private onToggleMenuClick = (): void => {
        this.collapsed = !this.collapsed;
        localStorage['MainMenuCollapsed'] = this.collapsed;
    }

    private setLanguage = (locale: string): void => {
        this.commonData.language = locale;
        window.location.reload();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/navmenu/navmenu.component.ts